import axios from "axios";

const WORKER_URL = "https://email.misty-butterfly-7739.workers.dev";

interface EmailPayload {
  name: string;
  email: string;
  message: string;
  subject: string;
  recaptchaToken: string;
}

interface EmailResponse {
  status: "success" | "error";
  message: string;
}

export async function sendContactEmail(payload: EmailPayload): Promise<{ success: boolean; message?: string }> {
  try {
    const response = await axios.post<EmailResponse>(`${WORKER_URL}/api/email`, payload, {
      headers: { "Content-Type": "application/json" },
    });
    return { success: response.data.status === "success", message: response.data.message };
  } catch (err: any) {
    return { success: false, message: err?.response?.data?.message ?? "Error sending email" };
  }
}
